interface AuthForgotPasswordState {
	auth?: {
		forgotPassword?: unknown
	}
}

const selectForgotPassword = (state: Record<string, unknown>) => (state as AuthForgotPasswordState).auth?.forgotPassword

export default selectForgotPassword
